module.exports = __webpack_public_path__ + "static/media/patient-story-avatar-maria.256c32d8.svg";